import { useAuth } from 'context/auth-context'
import Basic from 'layouts/authentication/sign-in'
import Dashboard from "layouts/dashboard";
import Cover from "layouts/authentication/sign-up";
import Category from "layouts/tables/Category";
import ProductDetails from "layouts/tables/Product_Details";
import OrderDetails from "layouts/tables/order_details";
import ShippingDetails from "layouts/tables/Shipping_details";
import Notification from "layouts/tables/notification";
import DiscountCode from "layouts/tables/discount_code";
import SalesReport from "layouts/tables/Reports/sales_report";
import Mobile from "layouts/authentication/sign-in/otp_mobile";
import VendorCategory from "layouts/tables/admin/vendor_categories";
import VendorAdminProducts from "layouts/tables/admin/vendor_products";
import Vendororders from "layouts/tables/admin/vendor_order_details";
import Approve from "layouts/tables/admin/vendor_approve";
import AdminReport from "layouts/tables/admin/Reports/admin_reports";
import VendorRegister from "layouts/tables/admin/vendor_register/vendor_register";
import Banner from "layouts/tables/admin/banner_content";
import Nonregistered from "layouts/authentication/non-registered";
import UserProfile from "layouts/tables/services/vendor_availability";
import VendorUserProfile from "layouts/tables/user_profile/vendor_user_profile";
import ServiceType from "layouts/tables/admin/services_type/ServiceType";
import ServiceRegistration from "layouts/tables/admin/service_register/service_registration";
import ServiceSpecialization from "layouts/tables/admin/service_specialization/ServiceSpecialization";
import ServiceApprove from "layouts/tables/admin/service_approve/service_approve";
import AdminRegister from "layouts/tables/admin/admin_register/admin_register";
import AdminControls from "layouts/tables/admin/admin_controls/admin_controls";
import ForgotPassword from "layouts/authentication/sign-in/forgot-password";
import VendorControls from "layouts/tables/admin/vendor_controls/vendor_controls";
import ServiceControls from "layouts/tables/admin/service_controls/service_controls";
import BusinessCategory from "layouts/tables/admin/business_category/business_category";
import StockUpdate from "layouts/tables/Product_Details/StockUpdate";
import AutoVendorApproval from "layouts/tables/admin/settings/autovendorapproval";


import ProtectedRoute from "routes/protected-routes";

import {
    Route,
    Navigate,
    Routes,
} from 'react-router-dom'
import InactiveVendors from 'layouts/tables/admin/inactive_vendors/inactive_vendors';
import AdminReferral from 'layouts/tables/admin/admin-referral/admin-referral';
import AppCategory from 'layouts/tables/admin/app_category/app_category';
import BusinessAdsPage from 'layouts/tables/admin/business_ads/businessads';
import PaymentPlans from 'layouts/authentication/sign-in/paymentplans';
import PaymentPlansPage from 'layouts/tables/admin/payment_plans/payment_plan_page';
import FeedbackViewPage from 'layouts/tables/admin/complaints/user_complaints';
import CouponManagement from 'layouts/tables/admin/coupons/coupons';
import IncentiveManagement from 'layouts/tables/admin/incentive/incentive_management';
import MarketingManagerControls from 'layouts/tables/admin/admin_controls/marketing_manager_controls';
import TelecallerControls from 'layouts/tables/admin/admin_controls/telecaller_controls';
import ColorSelectionPage from 'layouts/tables/admin/color_selection/color_selection';
import ContactUs from 'layouts/authentication/sign-in/contact';
import TermsAndConditions from 'layouts/tables/admin/termsandconditions/termsandconditions';
import StockHistory from 'layouts/tables/Product_Details/StockHistory';
import InactiveProductsPage from 'layouts/tables/Product_Details/InactiveProductsPage';
import VerifyVendors from "layouts/tables/admin/vendor_approve/verify_vendors";
import VerifyServiceProviders from "layouts/tables/admin/service_approve/verify_serviceprovider";

export default function AppRoutes() {

    const { isAuthenticated } = useAuth()

    return (
        <Routes>
            <Route
                path="/"
                element={
                    isAuthenticated ? (
                        <Navigate to="/dashboard" />
                    ) : (
                        <Navigate to="/login" />
                    )
                }
            />
            <Route path="/login" element={<Basic />} />

            <Route path="/admin/login" element={<Basic />} />
            <Route path="/sign_up" element={<Cover />} />

            <Route
                path="/dashboard"
                element={
                    <ProtectedRoute>
                        <Dashboard />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admins/"
                element={<ProtectedRoute><Dashboard /></ProtectedRoute>}
            />
            <Route path="/product_management/Category" element={<ProtectedRoute><Category /></ProtectedRoute>} />
            <Route
                path="/admin/vendors/unverified"
                element={
                    <ProtectedRoute>
                        <VerifyVendors />
                    </ProtectedRoute>
                }
            />
<Route
  path="/admin/services/unverified"
  element={
    <ProtectedRoute>
      <VerifyServiceProviders />
    </ProtectedRoute>
  }
/>

            <Route path="/admin/Coupons" element={<ProtectedRoute><CouponManagement /></ProtectedRoute>} />
            <Route
                path="/product_management/Products"
                element={<ProtectedRoute><ProductDetails /></ProtectedRoute>}
            />
            <Route
                path="/product_management/Products"
                element={<ProtectedRoute><ProductDetails /></ProtectedRoute>}
            />
            <Route
                path="/product_management/Stock_Update"
                element={<ProtectedRoute><StockUpdate /></ProtectedRoute>}
            />
            <Route
                path='/product_management/inactive_products'
                element={<ProtectedRoute><InactiveProductsPage /></ProtectedRoute>}
            />
            <Route
                path="/product_management/Stock_History"
                element={<ProtectedRoute><StockHistory /></ProtectedRoute>}
            />

            <Route path="/admin/Incentive" element={<ProtectedRoute><IncentiveManagement /></ProtectedRoute>} />
            <Route
                path="/product_management/Products"
                element={<ProtectedRoute><ProductDetails /></ProtectedRoute>}
            />
            <Route
                path="/order_management/OrderDetails"
                element={<ProtectedRoute><OrderDetails /></ProtectedRoute>}
            />
            <Route
                path="/admin/Appcolormanagement"
                element={<ProtectedRoute><ColorSelectionPage /></ProtectedRoute>}
            />
            <Route path="/payment-plans" element={<PaymentPlans />} />
            <Route
                path="/promotion_discount/discount_code"
                element={<ProtectedRoute><DiscountCode /></ProtectedRoute>}
            />

            <Route
                path="/order_management/Shipping_details"
                element={<ProtectedRoute><ShippingDetails /></ProtectedRoute>}
            />
            <Route
                path="/businessads"
                element={<ProtectedRoute><BusinessAdsPage /></ProtectedRoute>}
            />

            <Route path="/notification" element={<ProtectedRoute><Notification /></ProtectedRoute>} />
            <Route path="/reports/sales_report" element={<ProtectedRoute><SalesReport /></ProtectedRoute>} />
            <Route path="/mobile" element={<Mobile />} />
            <Route
                path="/vendor_management/Registration"
                element={<ProtectedRoute><VendorRegister /></ProtectedRoute>}
            />
            <Route
                path="/vendor_management/Approve_Request"
                element={<ProtectedRoute><Approve /></ProtectedRoute>}
            />
            <Route
                path="/vendor_management/Inactive_Vendors"
                element={<ProtectedRoute><InactiveVendors /></ProtectedRoute>}
            />
            <Route
                path="/vendor_management/Vendor_Products"
                element={<ProtectedRoute><VendorAdminProducts /></ProtectedRoute>}
            />
            <Route path="/contact" element={<ContactUs />} />
            <Route
                path="/vendor_management/Order_Details"
                element={<ProtectedRoute><Vendororders /></ProtectedRoute>}
            />
            <Route
                path="/vendor_management/Vendor_Categories"
                element={<ProtectedRoute><VendorCategory /></ProtectedRoute>}
            />
            <Route
                path="/vendor_management/business_category"
                element={<ProtectedRoute><BusinessCategory /></ProtectedRoute>}
            />
            {/*<Route
            path="/admins/notifications"
            element={<ProtectedRoute><VendorNotifications /></ProtectedRoute>}
            /> */}
            <Route
                path="/report_management/sales_reports"
                element={<ProtectedRoute><AdminReport /></ProtectedRoute>}
            />
            <Route
                path="/admins/banner_content"
                element={<ProtectedRoute><Banner /></ProtectedRoute>}
            />
            <Route
                path="/admins/terms_and_conditions"
                element={<ProtectedRoute><TermsAndConditions /></ProtectedRoute>}
            />
            <Route
                path="/Register"
                element={<Nonregistered />}
            />

            <Route
                path="/service_management/Registration"
                element={<ProtectedRoute><ServiceRegistration /></ProtectedRoute>}
            />

            <Route
                path="/service_management/service_approve"
                element={<ProtectedRoute><ServiceApprove /></ProtectedRoute>}
            />
            <Route
                path="/services/UserProfile"
                element={<ProtectedRoute><UserProfile /></ProtectedRoute>}
            />

            <Route
                path="/vendor/UserProfile"
                element={<ProtectedRoute><VendorUserProfile /></ProtectedRoute>}
            />
            <Route
                path="/service_management/service_type"
                element={<ProtectedRoute><ServiceType /></ProtectedRoute>}
            />

            <Route
                path="/vendor_controls"
                element={<ProtectedRoute><VendorControls /></ProtectedRoute>}
            />

            <Route
                path="/service_controls"
                element={<ProtectedRoute><ServiceControls /></ProtectedRoute>}
            />

            <Route
                path="/admin_register"
                element={<ProtectedRoute><AdminRegister /></ProtectedRoute>}
            />
            <Route
                path="/admin/settings/auto-vendor-approval"
                element={
                    <ProtectedRoute>
                        <AutoVendorApproval />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/admin_controls"
                element={<ProtectedRoute><AdminControls /></ProtectedRoute>}
            />
            <Route
                path="/marketing_manager_controls"
                element={<ProtectedRoute><MarketingManagerControls /></ProtectedRoute>}
            />
            <Route
                path="/telecaller_controls"
                element={<ProtectedRoute><TelecallerControls /></ProtectedRoute>}
            />
            <Route
                path="/service_management/service_specialization"
                element={<ProtectedRoute><ServiceSpecialization /></ProtectedRoute>}
            />

            <Route
                path="/admin_referrals"
                element={<ProtectedRoute><AdminReferral /></ProtectedRoute>}
            />
            <Route
                path="/app_management/app_category"
                element={<ProtectedRoute><AppCategory /></ProtectedRoute>}
            />
            <Route
                path="/forgot-password"
                element={<ForgotPassword />}
            />
            <Route path="*" element={<Navigate to="/" replace />} />

            <Route
                path="/admin/Payment_Plans"
                element={<ProtectedRoute><PaymentPlansPage /></ProtectedRoute>}
            />
            <Route
                path="/complaints"
                element={<ProtectedRoute><FeedbackViewPage /></ProtectedRoute>}
            />
        </Routes>
    )
}